import { takeEvery, call, all, fork, put } from "@redux-saga/core/effects";
import { FETCH_USERS, SET_USERS, FETCH_USER, SET_USER } from "redux/constants/portal";
import { setIsLoadingUsers, setIsLoadingUser } from "redux/actions/portal/usersActionCreator";
import { fetchUsers } from "api/UsersApi";
import { getUserData } from "api/UserApi";

/***** WORKERS *****/

function* handleFetchUsers({ payload }) {
  try {
    const { tenant_id } = payload;

    yield put(setIsLoadingUsers(true));

    const usersResponse = yield call(fetchUsers, tenant_id);
    const filteredUsers = usersResponse.filter((user) => user.email_address);
    yield put({ type: SET_USERS, payload: filteredUsers });
    yield put(setIsLoadingUsers(false));
  } catch (error) {
    console.error(error);
    yield put(setIsLoadingUsers(false));
  }
}

function* handleFetchUser({ payload }) {
  try {
    const { tenant_id, auth0_id } = payload;

    yield put(setIsLoadingUser(true));

    const res = yield call(getUserData, auth0_id, tenant_id);

    yield put({ type: SET_USER, payload: res });
    yield put(setIsLoadingUser(false));
  } catch (error) {
    console.error(error);
    yield put(setIsLoadingUsers(false));
  }
}

/***** WATCHERS *****/

function* watchFetchUsers() {
  yield takeEvery(FETCH_USERS, handleFetchUsers);
}

function* watchFetchUser() {
  yield takeEvery(FETCH_USER, handleFetchUser);
}

export function* rootUsersSaga() {
  yield all([fork(watchFetchUsers), fork(watchFetchUser)]);
}
